import { API } from "../../../../services/api/types";

export const topOffset = 650;

export const getActiveArticleStatus = (
  articles: API.Article[],
  articleIdToYOffsetMap: { [key: number]: number },
  scrollPosition: number
) => {
  const articleIdToYOffsetArray = Object.entries(articleIdToYOffsetMap).sort(
    (a, b) => a[1] - b[1]
  );

  let currentArticle = null;
  let nextArticle = null;
  let progress = 0;

  for (const i in articleIdToYOffsetArray) {
    const index = Number(i);
    const isLast = index === articleIdToYOffsetArray.length - 1;
    const yOffset = (articleIdToYOffsetArray?.[index]?.[1] || 0) - topOffset;
    const nextYOffset =
      (articleIdToYOffsetArray?.[index + 1]?.[1] || 0) - topOffset;
    const isOverCurrent = scrollPosition > yOffset;
    const isOverNext = !isLast && scrollPosition > nextYOffset!;
    const isOverFirstArticle = index === 0 && scrollPosition < yOffset;

    if (isOverFirstArticle) {
      currentArticle = articles[0];
      nextArticle = articles?.[1];
      break;
    }

    if (isOverCurrent && !isOverNext) {
      currentArticle = articles[index];
      nextArticle = articles?.[index + 1];

      progress = (scrollPosition - yOffset) / ((nextYOffset || 0) - yOffset);

      break;
    }
  }

  return {
    currentArticle: currentArticle!,
    nextArticle,
    progress,
  };
};
